export function renameFile (file: File, newName: string) {
  return new File([file], newName, { type: file.type });
}

export function formatDateTime (): string {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  return `${day}${month}-${seconds}`;
}

export function processFile (imageFile: File, previousImages: string[]) {
  if (previousImages.includes(imageFile.name)) {
    const formattedDate = formatDateTime();
    const newName =
      imageFile.name.replace(/\.[^/.]+$/, '') + '-' + formattedDate + '.jpeg';
    return renameFile(imageFile, newName);
  }
  return imageFile;
}
